import { createRouter, createWebHistory } from 'vue-router'
const { getRouterBase, normalizeLegacyHashUrl } = require('./historyModeUrls.cjs');
import auth from './auth'
import projects from './projects'
import chat from './chat'
import settings from './settings'
import timesheet from './timesheet'
import milestonesheet from './milestonesheet'
import payment from './payment';
import reports from './reports';
import document from './document';
import note from './note';
import myDailyTask from './myDailyTask';
import preview from './preview';
import digitalOffice from './digitalOffice';
import digitalProcess from './digitalProcess';

import { useCustomComposable } from '@/composable'
import chargebeeRouter from "../plugins/chargebee/router";
import paddleRouter from "../plugins/paddle/router";
import dashboard from "../plugins/dashboard/router";
import { apiRequestWithoutCompnay } from '@/services'
import * as env from '@/config/env';
import Cookies from 'js-cookie'
import Store from '@/store/index'
const { selectAssignedCompany } = require('@/utils/ritaLogin.cjs');
const {
	EOFFICE_PERMISSION_PATHS,
	getEofficeRoutePermissions,
	hasEofficeAccess,
	isEofficePermissionAllowed,
} = require('@/utils/eofficePermissions.cjs');
const checkoutRoute = process.env.VUE_APP_PAYMENTMETHOD === "chargebee" ? chargebeeRouter?.checkoutRoute : process.env.VUE_APP_PAYMENTMETHOD === "paddle" ? paddleRouter?.checkoutRoute : [];


const routes = [
	...auth,

	// PROJECT ROUTES
	...projects,

	// PROJECT ROUTES
	...chat,

	// SETTINGS ROUTES
	...settings,
	
	// TIMESHEET ROUTES
	...timesheet,

	//MILESTONE ROUTES
	...milestonesheet,

	// PAYMENTS ROUTES
	...payment,

	// DASHBOARD ROUTES
	...dashboard.dashboardRouter,

	// REPORTS ROUTE
	...reports,
	...digitalOffice,
	...digitalProcess,
	{
		path: '/download',
		name: 'Download',
		component: () => import('@/views/Policy/Download.vue'),
		meta: {
			requiresAuth: false,
			public: true,
			title: 'Download'
		}
	},
	{
		path: "/:catchAll(.*)",
		name: "404",
		component: () => import(/* webpackChunkName: "404" */ '@/views/NotFound'),
		meta: {
			title: '404'
		}
	},
	{
		path: '/policy',
		name: 'Policy',
		component: () => import('@/views/Policy/Policy.vue'),
		meta: {
			requiresAuth: false,
			public: true, // 👈 thêm cái này
			title: 'Policy'
		}
	},
		{
		path: '/support',
		name: 'support',
		component: () => import('@/views/Policy/Support.vue'),
		meta: {
			requiresAuth: false,
			public: true, // 👈 thêm cái này
			title: 'Support'
		}
	},
		{
		path: '/terms',
		name: 'Terms',
		component: () => import('@/views/Policy/Term.vue'),
		meta: {
			requiresAuth: false,
			public: true, // 👈 thêm cái này
			title: 'Terms of Service'
		}
	},
	...checkoutRoute,
	...document,
	...note,
	...myDailyTask,
	...preview
]

normalizeLegacyHashUrl(window.location, window.history);

const router = createRouter({
	history: createWebHistory(getRouterBase(window.location.pathname)),
	routes
})

// const authInst = getAuth();
const jsonData = require('../.././brandSettings.json');
const {setTitle} = useCustomComposable()
const {checkPermission} = useCustomComposable()

function findPermissionRule(rules, path) {
	return path.split('.').reduce((rule, key) => rule?.[key], rules);
}

async function canAccessEofficeRoute(to) {
	const permissionPaths = getEofficeRoutePermissions(to.name);
	const isEofficeHome = to.name === 'DigitalOfficeHome';
	if (!permissionPaths.length && !isEofficeHome) return true;

	let rules = Store.getters['settings/rules'] || {};
	if (!Object.keys(rules).length) {
		try {
			await Store.dispatch('settings/setRules');
			rules = Store.getters['settings/rules'] || {};
		} catch (error) {
			console.error('Unable to load E-Office permissions:', error);
			return true;
		}
	}

	if (!rules.eoffice) return true;
	if (!Object.keys(Store.getters['settings/companyUserDetail'] || {}).length) return true;
	if (!isEofficePermissionAllowed(checkPermission('eoffice'))) return false;

	const paths = isEofficeHome ? Object.values(EOFFICE_PERMISSION_PATHS) : permissionPaths;
	const permissions = Object.fromEntries(paths.map((path) => [
		path,
		findPermissionRule(rules, path) ? checkPermission(path) : undefined,
	]));
	return hasEofficeAccess(permissions);
}

router.beforeEach(async(to, _, next) => {
	if(to.meta.public === true){   // 👈 thêm dòng này
        next();
        return;
    }
	let query = to.query;
	let fullPath = to.fullPath;
	if (to.path == '/business' && to.query.code) {
		Cookies.set('refferCode', to.query.code, { expires: 365 });
		let coded = to.query;
		delete coded.code;
		query = coded;
		fullPath = removeCodeParam(to.fullPath);
	}
	const localUserId = localStorage.getItem("userId");
	const app = localUserId ? await apiRequestWithoutCompnay('get',`${env.USER_UPATE}/${localUserId}`) : null;
	let user = app && app?.status === 200 ? app?.data || null : null;
	
	// onAuthStateChanged(authInst, (user) => {
		// CHECK META FOR AUTH REQUIRED
		// const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
		const requiresAuth = to.meta.requiresAuth;
		const token = Cookies.get('accessToken') || '';
		// SET PAGE TITLE
		setTitle({title: to.meta.title, prefix: jsonData?.productName ? `${jsonData.productName} | ` : ''});

		if(user === null && requiresAuth === true) {
			// IF USER IS NOT LOGGED IN AND REQUESTS AUTH REQUIRED PAGE
			next({name: 'Log-in', query: {redirect_url: fullPath}});
			return;
		} else if(user !== null && requiresAuth === false) {
			// IF USER IS LOGGED IN AND REQUESTS NO AUTH REQUIRED PAGE
			if(to.meta.title === 'Support'){
				next();
			}else if(token && !user?.AssignCompany?.length){
				next({name: "Create_Company", query: query});
			}else{
				const targetCompanyId = selectAssignedCompany(
					localStorage.getItem('selectedCompany') || '',
					user?.AssignCompany,
				);
				if (targetCompanyId) localStorage.setItem('selectedCompany', targetCompanyId);
				next({name: "Home", params: {
					cid: targetCompanyId,
				}, query: query});
			}
			return;
		} else {
			if (!await canAccessEofficeRoute(to)) {
				next({ name: 'Home', params: { cid: to.params.cid || localStorage.getItem('selectedCompany') } });
				return;
			}
			next();
			return;
		}
	// })
})

function removeCodeParam(url) {
    const [path, queryString] = url.split("?");
    if (!queryString) return url;

    const params = new URLSearchParams(queryString);
    params.delete("code");

    return params.toString() ? `${path}?${params.toString()}` : path;
}

export default router;
